import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_URL } from '../common/constant';

const RequirementsList = () => {
    const [requirements, setRequirements] = useState([]);
 

    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 20;

    const token = localStorage.getItem('token');

    useEffect(() => {
        const fetchRequirements = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/requirements?page=${currentPage}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setRequirements(response.data.data);
                setTotalItems(response.data.totalItems);
            } catch (error) {
                console.log('Error==>', error);
                toast.error("Failed to fetch requirements.");
            } finally {
                setLoading(false);
            }
        };
    
        fetchRequirements();
    }, [currentPage, token]);

    if (loading) {
        return <div>Loading...</div>;
    }

    // Calculate total pages
    const pageCount = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-3xl font-bold mb-4">Requirements List</h1>
            {requirements.length > 0 ? (
                <>
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white border border-gray-300 rounded shadow-md">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-2 text-left">S/N</th>
                                    <th className="border border-gray-300 p-2 text-left">Name</th>
                                    <th className="border border-gray-300 p-2 text-left">Mobile Number</th>
                                    <th className="border border-gray-300 p-2 text-left">Email</th>
                                    <th className="border border-gray-300 p-2 text-left">Requirement</th>
                                    <th className="border border-gray-300 p-2 text-left">Created At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {requirements.map((req, index) => {
                                    const serialNumber = startIndex + index + 1; // Calculate serial number correctly
                                    return (
                                        <tr key={req._id} className={`hover:bg-gray-100 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
                                            <td className="border border-gray-300 p-2">{serialNumber}</td> {/* Serial Number */}
                                            <td className="border border-gray-300 p-2">{req.name}</td>
                                            <td className="border border-gray-300 p-2">{req.mobileNumber}</td>
                                            <td className="border border-gray-300 p-2">{req.email}</td>
                                            <td className="border border-gray-300 p-2">{req.requirement}</td>
                                            <td className="border border-gray-300 p-2">{new Date(req.createdAt).toLocaleString()}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="flex justify-center mt-4">
                        <button
                            onClick={() => handlePageChange(currentPage > 1 ? currentPage - 1 : 1)}
                            className="px-4 py-2 border border-gray-300 rounded mr-2 disabled:opacity-50"
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        {Array.from({ length: pageCount }, (_, index) => (
                            <button
                                key={index + 1}
                                onClick={() => handlePageChange(index + 1)}
                                className={`px-4 py-2 border border-gray-300 rounded mx-1 ${currentPage === index + 1 ? 'bg-blue-500 text-white' : ''}`}
                            >
                                {index + 1}
                            </button>
                        ))}
                        <button
                            onClick={() => handlePageChange(currentPage < pageCount ? currentPage + 1 : pageCount)}
                            className="px-4 py-2 border border-gray-300 rounded ml-2 disabled:opacity-50"
                            disabled={currentPage === pageCount}
                        >
                            Next
                        </button>
                    </div>
                </>
            ) : (
                <p>No requirements found.</p>
            )}
            <ToastContainer />
        </div>
    );
};

export default RequirementsList;
